export default class formConfig {
  // 修改密码
  static configList() {
    return [
      {
        title: "密码修改",
        name: "1",
        icon: "",
        tipsList: [
          { text: "修改密码前，请插入对应的密保锁！" }
        ],
        formConfigList: [
          {
            label: "原密码：",
            value: "ymm",
            slotName: "ymm",
            type: "password",
            required: true,
            tip: "（可输入20个字符）",
            rule: [
              {
                required: true,
                message: "请输入原密码",
                trigger: "blur"
              }
            ]
          },
          {
            label: "新密码：",
            value: "yhmm",
            slotName: "yhmm",
            type: "password",
            required: true,
            tip: "（可输入20个字符）",
            rule: [
              {
                required: true,
                message: "请输入新密码",
                trigger: "blur"
              },
            ]
          },
          {
            label: "确认密码：",
            value: "yhmmqr",
            slotName: "yhmmqr",
            type: "password",
            required: true,
            tip: "（可输入20个字符）",
            rule: [
              {
                required: true,
                message: "请再次输入新密码",
                trigger: "blur"
              },
            ]
          },
          {
            slotName: "tips",
            type: "slot"
          }
        ]
      }
    ];
  }
}
